import React from 'react'
import styled from 'styled-components'
import { Separator } from '../../../Separator/Separator'

type Props = {
    minWidth: number
    type?: string
    iconType: string
    styledIcon: StyleSheet
    status: string
    styledStatus?: StyleSheet
    statusColor: string
    backgroundColor: string
    children: React.ReactNode
    className?: string
    typeColor?: string
}

const CardAvailability = ({
    minWidth = 312,
    type,
    iconType,
    styledIcon,
    status,
    styledStatus,
    statusColor,
    typeColor,
    backgroundColor,
    children,
    className
}: Props): JSX.Element => {
    return (
        <Wrapper className={className}>
            <DivHeader width={minWidth} statusColor={statusColor} backgroundColor={backgroundColor}>
                {type ? (
                    <DivType>
                        <SpanType color={typeColor ?? statusColor}>{type}</SpanType>
                        <SpanIcon style={styledIcon}>
                            <i className={iconType} />
                        </SpanIcon>
                    </DivType>
                ) : (
                    <DivStatus style={styledStatus}>
                        <StatusPoint width={16} height={16} statusColor={statusColor} />
                        <StatusText sizedStatus={24}>{status}</StatusText>
                    </DivStatus>
                )}
            </DivHeader>
            {children ? (
                <DivContent>
                    {type ? (
                        <>
                            <DivStatus style={styledStatus} sizedStatus={20}>
                                <StatusPoint width={12} height={12} statusColor={statusColor} />
                                {status}
                            </DivStatus>
                            <Separator
                                orientation={'horizontal'}
                                width={'100%'}
                                height={'1px'}
                                style={{ margin: 0, padding: 0 }}
                            />
                        </>
                    ) : null}
                    <ChildrenDiv>{children}</ChildrenDiv>
                </DivContent>
            ) : null}
        </Wrapper>
    )
}
export default CardAvailability

const Wrapper = styled.div`
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    min-width: ${({ width }) => width}px;
    div {
        font-family: SourceSansPro-Semibold, Arial, Helvetica Neue, Helvetica, sans-serif;
    }
`

export const DivHeader = styled.div`
    display: flex;
    position: relative;
    align-items: center;
    justify-content: flex-start;
    padding: 24px 16px;
    background-color: ${({ backgroundColor }) => backgroundColor || '#f0fffa'};
    min-width: ${({ width }) => width + 2}px;
    height: 61px;
    border: 2px solid ${({ statusColor }) => statusColor || 'var(--green-700)'};
    border-radius: 3px 3px 0 0;
`

export const DivType = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 600;
    font-size: 22px;
`

const SpanType = styled.span`
    font-size: 22px;
    color: ${({ color }) => color || `var(--green-700)`};
`
const SpanIcon = styled.span`
    font-size: 32px;
`

const StatusPoint = styled.div`
    background-color: ${({ statusColor }) => statusColor || `var(--green-700)`};
    border-radius: 50%;
    border: none;
    width: ${({ width }) => width}px;
    height: ${({ height }) => height}px;
`

export const DivStatus = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    font-weight: 600;
`
const StatusText = styled.div`
    font-weight: 600;
    color: var(--gray-800);
    font-size: ${({ sizedStatus }) => sizedStatus}px;
`

export const DivContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 16px;
    padding: 16px 24px;
    border: 1px solid var(--gray-400);
    border-top: none;
    width: 100%;
    border-radius: 0 0 3px 3px;
`
const ChildrenDiv = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 16px;
    width: 100%;
    flex-wrap: wrap;
`
